import { useEffect } from "react";

const LiveChatWidget = () => {
    useEffect(() => {
        window.__lc = window.__lc || {};
        window.__lc.license = 14551761; // Replace with your license ID

        const script = document.createElement("script");
        script.src = "https://cdn.livechatinc.com/tracking.js";
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return null; // This component only injects the script
};

export default LiveChatWidget;
